<div class="space-y-4 sm:space-y-5 p-0">
  <!-- Número de documento -->
  <div>
    <label class="block text-sm font-medium text-slate-700 mb-1.5">Número de Doc.</label>
    <div class="flex flex-col lg:flex-row gap-2.5 sm:gap-3">
      <app-select
        class="w-full sm:hidden"
        [options]="tipoBusqueda"
        [formField]="$any(formularioCliente.tipo_documento)"
        placeholder="Tipo de documento"
      />
      <div class="hidden sm:inline-flex">
        <app-select-button
          [options]="tipoBusqueda"
          [value]="formularioCliente.tipo_documento().controlValue()"
          (onChange)="formularioCliente.tipo_documento().value.set($event)"
          styleClass="text-xs sm:text-sm"
          ariaLabel="Tipo de documento"
        />
      </div>
      <div class="flex flex-1 rounded-lg border border-slate-200 bg-white transition-all duration-150 overflow-hidden"
        [class.border-red-400]="formularioCliente.dniRuc().invalid() && formularioCliente.dniRuc().touched()"
        [class.focus-within:ring-2]="true"
        [class.focus-within:ring-accent-500/20]="!formularioCliente.dniRuc().invalid() || !formularioCliente.dniRuc().touched()"
        [class.focus-within:border-accent-500]="!formularioCliente.dniRuc().invalid() || !formularioCliente.dniRuc().touched()"
        [class.focus-within:ring-red-500/20]="formularioCliente.dniRuc().invalid() && formularioCliente.dniRuc().touched()"
        [class.focus-within:border-red-500]="formularioCliente.dniRuc().invalid() && formularioCliente.dniRuc().touched()">
        <input
          id="search"
          type="text"
          [formField]="$any(formularioCliente.dniRuc)"
          [placeholder]="'Ingresar ' + (formularioCliente.tipo_documento().controlValue() | tipo_documento)"
          class="w-full border-0 bg-transparent px-3 py-2.5 text-sm focus:outline-none focus:ring-0 placeholder:text-slate-400"
        />
        <button
          type="button"
          class="shrink-0 flex items-center justify-center px-4 bg-accent-600 text-white hover:bg-accent-500 active:bg-accent-700 transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
          (click)="buscarSunat()"
          [disabled]="formularioCliente.dniRuc().invalid() && formularioCliente.dniRuc().touched()"
          aria-label="Buscar en RENIEC/SUNAT"
        >
          <i class="bi bi-search"></i>
        </button>
      </div>
    </div>
    @if (formularioCliente.dniRuc().invalid() && formularioCliente.dniRuc().touched()) {
      <small class="text-red-600 text-xs block mt-1.5">{{ formularioCliente.dniRuc().errors() | formErrorMessage }}</small>
    }
  </div>

  <!-- Nombre -->
  <div>
    <label class="block text-sm font-medium text-slate-700 mb-1.5">Nombres y Apellidos</label>
    <div class="flex items-center rounded-lg border border-slate-200 bg-white transition-all duration-150 focus-within:ring-2 focus-within:ring-accent-500/20 focus-within:border-accent-500 overflow-hidden"
      [class.border-red-400]="formularioCliente.nombre().invalid() && formularioCliente.nombre().touched()">
      <span class="flex items-center justify-center pl-3 pr-2 text-slate-400 shrink-0">
        <i class="bi bi-person text-sm"></i>
      </span>
      <input
        id="nombre"
        type="text"
        [formField]="$any(formularioCliente.nombre)"
        class="w-full border-0 bg-transparent py-2.5 pr-3 text-sm focus:outline-none focus:ring-0 placeholder:text-slate-400"
        placeholder="Ingrese el nombre completo"
      />
    </div>
    @if (formularioCliente.nombre().invalid() && formularioCliente.nombre().touched()) {
      <small class="text-red-600 text-xs block mt-1.5">{{ formularioCliente.nombre().errors() | formErrorMessage }}</small>
    }
  </div>

  <!-- Dirección -->
  <div>
    <label class="block text-sm font-medium text-slate-700 mb-1.5">Dirección</label>
    <div class="flex items-center rounded-lg border border-slate-200 bg-white transition-all duration-150 focus-within:ring-2 focus-within:ring-accent-500/20 focus-within:border-accent-500 overflow-hidden"
      [class.border-red-400]="formularioCliente.direccion().invalid() && formularioCliente.direccion().touched()">
      <span class="flex items-center justify-center pl-3 pr-2 text-slate-400 shrink-0">
        <i class="bi bi-geo-alt text-sm"></i>
      </span>
      <input
        id="direccion"
        type="text"
        [formField]="$any(formularioCliente.direccion)"
        autocomplete="street-address"
        class="w-full border-0 bg-transparent py-2.5 pr-3 text-sm focus:outline-none focus:ring-0 placeholder:text-slate-400"
        placeholder="Ingrese la dirección"
      />
    </div>
    @if (formularioCliente.direccion().invalid() && formularioCliente.direccion().touched()) {
      <small class="text-red-600 text-xs block mt-1.5">{{ formularioCliente.direccion().errors() | formErrorMessage }}</small>
    }
  </div>

  <!-- Número celular -->
  <div>
    <label class="block text-sm font-medium text-slate-700 mb-1.5">Número de Celular</label>
    <div class="flex items-center rounded-lg border border-slate-200 bg-white transition-all duration-150 focus-within:ring-2 focus-within:ring-accent-500/20 focus-within:border-accent-500 overflow-hidden">
      <span class="flex items-center justify-center pl-3 pr-2 text-slate-400 shrink-0">
        <i class="bi bi-telephone text-sm"></i>
      </span>
      <app-input-mask
        inputId="numero_celular"
        mask="999-999-999"
        [(ngModel)]="numero_celular"
        placeholder="999-999-999"
        styleClass="!border-0 !rounded-none !shadow-none"
        class="flex-1"
      />
    </div>
    @if (numero_celular && numero_celular.length > 0 && numero_celular.length < 9) {
      <small class="text-red-600 text-xs block mt-1.5">El número de celular es inválido.</small>
    }
  </div>

  <!-- Botón -->
  <div class="flex justify-center pt-3 sm:pt-5">
    <app-button
      label="Crear Cliente"
      icon="bi bi-plus-lg"
      size="lg"
      (onClick)="crearCliente()"
      [disabled]="formularioCliente().invalid()"
      class="w-full sm:w-auto [&>button]:w-full sm:[&>button]:w-auto"
    />
  </div>
</div>
